import { render, staticRenderFns } from "./OrderFilters.vue?vue&type=template&id=6ea7434a&scoped=true&"
import script from "./OrderFilters.vue?vue&type=script&lang=js&"
export * from "./OrderFilters.vue?vue&type=script&lang=js&"
import style0 from "./OrderFilters.vue?vue&type=style&index=0&id=6ea7434a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea7434a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBadge,VBtn,VBtnToggle})
